import type { ReactElement } from 'react'

import { IR_GOVERNANCE_ROUTE } from '@/utils/enroutes'

import { LinkCard } from '@/components/elements/LinkCard'
import { LinkCardList } from '@/components/elements/LinkCardList'
import { SectionTitle } from '@/components/elements/SectionTitle'
import { Spacer } from '@/components/elements/Spacer'
import { TitleLayout } from '@/components/enlayout'
import { Head } from '@/components/enlayouts/Head'
import { Layout } from '@/components/enlayouts/Ir'

export const GovernancePage = () => {
  return (
    <Layout>
      <SectionTitle
        color="normal"
        enTitleText="Corporate Governance"
        subTitleText=""
      />
      <Spacer h={{ sp: 70, pc: 120 }} />
      <LinkCardList>
        {IR_GOVERNANCE_ROUTE.subdirectories.map(
          ({ name, path, imagePath, ...rest }) => (
            <LinkCard
              title={name}
              link={path}
              imgPath={imagePath}
              key={path}
              {...rest}
            />
          )
        )}
      </LinkCardList>
    </Layout>
  )
}

GovernancePage.getLayout = (page: ReactElement) => {
  const breadCrumbs = [
    { name: 'Home', path: '/en/' },
    { name: 'Investor Relations', path: '/en/ir' },
    { name: 'Corporate Governance', path: '' },
  ]
  return (
    <>
      <Head
        title="Corporate Governance"
        description="Corporate Governance"
        ogp={{ url: 'en/ir/governance' }}
      />
      <TitleLayout
        title="Investor Relations"
        subTitle=""
        breadCrumbs={breadCrumbs}
      >
        {page}
      </TitleLayout>
    </>
  )
}
